import React, { Component } from "react";
import "./Home.css";
import Footer from "../../footer/Footer";
import { Parallax, Background } from "react-parallax";
import { SocialIcon } from "react-social-icons";
import { Redirect } from "react-router";
import history from "../../history/History";
import gif from "../../pictures/app.gif"

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, redirect: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleOnClick = () => {
    this.setState({ redirect: 1 });
  };

  render() {
    if (this.state.redirect === 1) {
      this.setState({ redirect: 0 });
      history.push("/");
      return (
        <Redirect
          to={{
            pathname: "/contact",
          }}
        />
      );
    }
    let style;
    if (this.state.width > 600) {
      style = {
        width: this.state.width + "px",
        height: this.state.height + "px",
      };
    } else {
      style = { width: "50%", height: "600px" };
    }
    return (
      <div
        style={{
          background: "linear-gradient( 0.4turn,rgb(253, 232, 135), orange)",
        }}
      >
        {/* <Parallax
                    className="header"
                    slowerScrollRate="true"
                    bgImage={require('../../pictures/landing_background.jpg')}
                    bgImageAlt="art"
                    bgStyle={{marginTop: "20px"}}
                    strength={200}
                >*/}
        <div className="main">
          {/*<div className="Prototypes" style={{height: this.state.height + 70 + "px"}}>
                            <div className="Prototypes-image-container">
                                <div className="Prototypes-image"/>

                            </div>
                        </div>*/}

          <div className="Explainer">
            <h1>Welcome!</h1>
            <h2>
              The Real Borat Coin<br></br>invented by the <br></br>Glorious
              people from
              <br></br> Republic of Kazakhstan
            </h2>
            <a href="https://t.me/theboratcoin">
              <button>SIGN UP TODAY</button>
            </a>
          </div>
          <div className="hover06">
            <figure>
              <img src="/static/media/app.2b706ffb.png" className="image" />
            </figure>
          </div>
        </div>

        <div className="count_down">
          <p className="contract_address">
            Contract address: <br /> 0x89f160e24f86b45f57320702c6814b86ca6ef03b
          </p>
          <h2>Stay tuned!</h2>
          <h3>
            Would be released on 31 of May
            <br />
            And dat would be very nice!
          </h3>
          <h5>Participate in our airdrop now!</h5>
          <CountDownTimer />
          <img src={gif}/>
        </div>
      </div>
    );
  }
}

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, redirect: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <div>
        <div
          className="Home-sidebar"
          style={{ width: this.state.width - 30 + "px" }}
        >
          <SocialIcon
            className="Sidebar-social"
            style={{ width: "25px", height: "25px", margin: "10px" }}
            color="white"
            url="http://twitter.com/artpieceio"
          />
          <SocialIcon
            className="Sidebar-social"
            style={{ width: "25px", height: "25px", margin: "10px" }}
            color="white"
            url="http://telegram.com/artpieceio"
          />
          <SocialIcon
            className="Sidebar-social"
            style={{ width: "25px", height: "25px", margin: "10px" }}
            color="white"
            url="http://facebook.com/artpieceio"
          />
          <SocialIcon
            className="Sidebar-social"
            style={{ width: "25px", height: "25px", margin: "10px" }}
            color="white"
            url="http://github.com/artpieceio"
          />
        </div>
      </div>
    );
  }
}

class CountDownTimer extends Component {
  state = {
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
    timeUp: false,
  };
  componentDidMount() {
    setInterval(() => {
      let eventDate = +new Date("05/31/2021");
      let difference = new Date("05/31/2021") - +new Date();
      if (difference < 1) {
        this.setState({ timeUp: true });
      } else {
        let days = Math.floor(difference / (1000 * 60 * 60 * 24));
        let hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((difference / (1000 * 60)) % 60);
        let seconds = Math.floor((difference / 1000) % 60);
        this.setState({
          hours: hours > 9 ? hours : `0${hours}`,
          minutes: minutes > 9 ? minutes : `0${minutes}`,
          seconds: seconds > 9 ? seconds : `0${seconds}`,
          days,
        });
      }
    }, 1000);
  }
  render() {
    const { days, hours, minutes, seconds, timeUp } = this.state;
    const dayString = days > 1 ? "days" : "day";
    return timeUp ? (
      <p>Event in progress</p>
    ) : (
      <p className="ptag">{`${days} ${dayString} ${hours} hours ${minutes}  minutes ${seconds} seconds`}</p>
    );
  }
}

class Countdown extends Component {
  render() {
    return (
      <div className="countdown">
        <section>
          <h1 id="roadmap">Roadmap</h1>
        </section>
        <section>
          <h1 id="about">About</h1>
          <p>borat coin is</p>
        </section>
      </div>
    );
  }
}
class Home extends Component {
  render() {
    return (
      <div className="homepage">
        <Header />
        <Countdown />
        <Footer />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js